<template>
	<div>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Opening Stock</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>

		    <v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" @input="fn_debounceSearch" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>

		    <!-- <div full-width slot="extension" class="search-filter">
		    	<v-text-field elevation-10  flat solo placeholder="Search..." v-model="searchValue" @input="fn_searchItem" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
		    	<div v-ripple class="filter-btn" @click="fn_getBottomMenu(904)">
		    		<v-icon>filter_list</v-icon>
		    		<span style="font-size: 48px;position: absolute;bottom: -14px;right: 6px;color: #4b77be;" v-if="selectionItems.brandId || selectionItems.categoryId || selectionItems.companyId">&bull;</span>
		    	</div>
		    </div> -->
		</v-toolbar>

		<div class="hasToolbar hasFooter hasExtension" v-scroll="onScroll">


			<v-list two-line nopadding>

				<!-- <v-subheader white-background subheader-ultra-dense>
		          Count: {{$root.numberToLocale(listItemObject.totalCount)}}
		        </v-subheader> -->

		        <v-subheader white-background subheader-dense>
					Count: {{$root.numberToLocale(listItemObject.totalCount, 1)}}
					<v-spacer></v-spacer>

					<div class="font11 mr-2" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openCategories" v-ripple>
						<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectionItems.categoryName ? selectionItems.categoryName : 'Category'}}</div>
						<v-icon>arrow_drop_down</v-icon>
					</div>

					<div class="font11 mr-2" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openBrands" v-ripple>
						<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectionItems.brandName ? selectionItems.brandName : 'Brand'}}</div>
						<v-icon>arrow_drop_down</v-icon>
					</div>

					<div class="font11" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openCompanies" v-ripple>
						<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectionItems.companyName ? selectionItems.companyName : 'Company'}}</div>
						<v-icon>arrow_drop_down</v-icon>
					</div>
				</v-subheader>

		        <v-divider></v-divider>

				<div v-for="(item, index) in listItemObject.items" :key="index">
					<!-- {{item}} -->

					<v-list-tile class="right-subtitle-tile">
					    <v-list-tile-content @click="fn_itemClick(item.transactionId)">

					      <v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
					      	<v-list-tile-sub-title class="mb-1">
					      		{{item.qty}} {{item.unitName}}
					      		<!-- <span v-if="item.packQuantity">({{item.packQuantity}})</span>   -->
					      		<span>X &#8377; {{item.rate ? $root.numberToLocale(item.rate) : 0}}</span>
					       		<span class="right_subtitle">&#8377; {{$root.numberToLocale(item.amount)}}</span> 
					   		</v-list-tile-sub-title>
					      <!-- <v-list-tile-sub-title v-if="$root.TransactionSettings.mrpWiseStock">MRP: <b>&#8377; {{item.mrp ? $root.numberToLocale(item.mrp) : 0}}</b></v-list-tile-sub-title> -->
					    </v-list-tile-content>

					    <!-- <v-list-tile-action>
					    	<v-btn icon flat @click="fn_getBottomMenu(902, item, index)"><v-icon>more_horiz</v-icon></v-btn>
					    </v-list-tile-action> -->
					</v-list-tile>

					<v-divider v-if="listItemObject.items.length-1 != index"></v-divider>
				</div>

				<!-- <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
					<div slot="no-more"></div>
					<div slot="no-results"></div>
				</infinite-loading> -->

				<!-- <div white-background padding-all-16 center-align v-if="loadMore">
		          <v-progress-circular indeterminate color="primary"></v-progress-circular>
		        </div> -->


			</v-list>

			<!-- <div class="display_msg" v-if="!listItemObject.items.length && !loadMore">There are no items</div> -->

			<transition name="fade" mode="out-in">
				<v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 162px);display: flex;align-items: center;">
					<v-card-text>

						<div center-align>
			            	<div @click="fn_new" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
			            		<i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
			            		<img src="../../../../assets/icon_wallet.svg" style="opacity:0.6;width:42px" alt="">
			            	</div><br>

			            	<p class="title light-opacity-color" style="line-height:28px !important">Add Opening Stock</p>
			            </div>

					</v-card-text>
				</v-card>
			</transition>

		</div>

		<v-footer white-background class="pl-3 pr-3" fixed style="border-top:0.5px #F0F0F0 solid;height:auto">
			<v-layout wrap align-center>
	    	  <v-flex xs4 style="text-align:left" v-ripple @click="qtySheet=true">
	    	  	<span v-if="stockSummary.unitItems.length">Total Qty<v-icon style="position:absolute">keyboard_arrow_up</v-icon></span>
	    	  </v-flex>
	    	  <v-flex xs8 style="text-align:right">Value: &nbsp;&#8377; {{$root.numberToLocale(stockSummary.totalAmount)}}</v-flex>
	    	</v-layout>
	    </v-footer>

	    <v-bottom-sheet v-model="qtySheet">
	    	<v-card>
	    	  <v-card-title noshadow>
	    	    Total Qty
	    	  </v-card-title>
	    	  <v-divider></v-divider>
	    	  <v-card-text> 
	    	    <span v-for="(item, index) in stockSummary.unitItems" :key="index" v-if="item.qty">
	    	    	{{item.unitName}} {{item.qty}}{{stockSummary.unitItems.length-1!=index ? ',' : ''}}
	    	    </span>
	    	  </v-card-text>
	    	</v-card>
	    </v-bottom-sheet>	

	    

		<v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

		<dialog-drive-alert ref="ref_dialogDriveAlert"></dialog-drive-alert>
		<dialog-selection-list ref="ref_dialogSelectionList" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-selection-list>
	</div>
</template>

<script>
var tagId = null;
const menuItem = require('../../../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../../../config.js').configs.bottomSheetMenu;
// const transactionForms = require('../../../../config.js').configs.transactionForms;

const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
const listIdObject = require('../../../../config.js').configs.mastersPredefinedLists;

import dialogDriveAlert from '../dialogs/dialog_drive_alert'
import dialogSelectionList from '../../../dialogs/dialog_selection_list'

// import InfiniteLoading from 'vue-infinite-loading';

	export default{
		props:['settings'],
		components: {
		    // InfiniteLoading,
		    'dialog-drive-alert':dialogDriveAlert,
			'dialog-selection-list':dialogSelectionList
		},
		data(){
			return{
				toolbarTitle:null,
				listItemObject:{"items":[], "totalCount":0},
				searchValue:'',
				infiniteId: +new Date(),
				startIndex:0,
				scrollPositionTop:0,


				selectedItem:null,
				itemIndex:null,

				snackbar:false,
				snackbar_msg:null,

				stockSummary: {totalAmount:0, unitItems:[]},
				qtySheet:false,

				// loading: false,
				searchItems: false,

				// filterObject:{},
				formId:null,
				dialogStorageId:null,

				selectionItems:{
					brandId:null,
					brandName:null,
					categoryId:null,
					categoryName:null,
					companyId:null,
					companyName:null
				},

				// selectionItems.brandId:null,
				// selectionItems.brandName:null,
				// selectionItems.categoryId:null,
				// selectionItems.categoryName:null,
				// selectionItems.companyId:null,
				// selectionItems.companyName:null,
				loadMore:false,
				showPlaceHolder:false
			}
		},
		methods:{

			onScroll (event) {
		        var element = event.target;
		        if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 150 <= element.documentElement.clientHeight)
		        {
		            console.log('scrolled');
		            if(this.listItemObject.items.length < this.listItemObject.totalCount){
		              this.fn_loadItems();
		            }
		        }
		    },

			fn_drafts: function(){
				this.$router.push({path:'/drafts', query:{tabIndex:1}});
			},
			fn_goBack: function(){
				this.$router.go(-1);
			},
			fn_menuItemClick: function(tagId, menuId, menuAction){
				if(menuAction=='edit'){
					this.fn_edit(this.selectedItem);
				}
				// else if(menuAction == 'filterCategory'){
				// 	let obj = {};
				// 	obj.functionName = 'productCategories';
				// 	obj.toolbarTitle = 'Select Category';
				// 	obj.itemId = this.selectionItems.categoryId;
				// 	obj.itemName = this.selectionItems.categoryName;
				// 	this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_category', obj);
				// }
				// else if(menuAction == 'filterBrand'){
				// 	let obj = {};
				// 	obj.functionName = 'listItems';
				// 	obj.toolbarTitle = 'Select Brand';
				// 	obj.itemId = this.selectionItems.brandId;
				// 	obj.itemName = this.selectionItems.brandName;
				// 	this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_brand', obj);
				// }
				// else if(menuAction == 'filterCompany'){
				// 	let obj = {};
				// 	obj.functionName = 'listItems';
				// 	obj.toolbarTitle = 'Select Company';
				// 	obj.itemId = this.selectionItems.companyId;
				// 	obj.itemName = this.selectionItems.companyName;
				// 	this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_company', obj);
				// }
				// else if(menuAction == 'clearallfilters'){
				// 	this.fn_clearAll();
				// }
			},

			fn_openCategories: function(){
				let obj = {};
				obj.functionName = 'productCategories';
				obj.toolbarTitle = 'Select Category';
				obj.itemId = this.selectionItems.categoryId;
				obj.itemName = this.selectionItems.categoryName;
				this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_category', obj);
			},
			// fn_openCategories: function(){
			// 	let viewDialogObject = { ToolbarTitle:"Category", fnName:"ProductCategoryDialog", ref:"ref_category", dbSearch:true };
			// 	if(this.selectionItems.categoryId && this.selectionItems.categoryName){
			// 		viewDialogObject.selectedItem = {"itemId":this.selectionItems.categoryId, "itemName":this.selectionItems.categoryName};
			// 		viewDialogObject.clearBtn = true;
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Account Group', 'ref_dialogSelectionList');
			// },

			fn_openBrands: function(){
				let obj = {};
				obj.functionName = 'listItems';
				obj.toolbarTitle = 'Select Brand';
				obj.itemId = this.selectionItems.brandId;
				obj.itemName = this.selectionItems.brandName;
				this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_brand', obj);
			},
			// fn_openBrands: function(){
			// 	let viewDialogObject = { ToolbarTitle:"Brand", fnName:"ListItemDialog", ref:"ref_brand", dbSearch:true };
			// 	viewDialogObject.listId = listIdObject.brandListGUID;
			// 	if(this.selectionItems.brandId && this.selectionItems.brandName){
			// 		viewDialogObject.selectedItem = {"itemId":this.selectionItems.brandId, "itemName":this.selectionItems.brandName};
			// 		viewDialogObject.clearBtn = true;
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Brand', 'ref_dialogSelectionList');
			// },

			fn_openCompanies: function(){
				let obj = {};
				obj.functionName = 'listItems';
				obj.toolbarTitle = 'Select Company';
				obj.itemId = this.selectionItems.companyId;
				obj.itemName = this.selectionItems.companyName;
				this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_company', obj);
			},
			// fn_openCompanies: function(){
			// 	let viewDialogObject = { ToolbarTitle:"Company", fnName:"ListItemDialog", ref:"ref_company", dbSearch:true };
			// 	viewDialogObject.listId = listIdObject.companyListGUID;
			// 	if(this.selectionItems.companyId && this.selectionItems.companyName){
			// 		viewDialogObject.selectedItem = {"itemId":this.selectionItems.companyId, "itemName":this.selectionItems.companyName};
			// 		viewDialogObject.clearBtn = true;
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Company', 'ref_dialogSelectionList');
			// },

			// fn_clearAll: function(){
			// 	this.selectionItems.categoryId = null;
			// 	this.selectionItems.brandId = null;
			// 	this.selectionItems.companyId = null;
			// 	localStorage.removeItem('transaction_filter');
			// 	this.fn_searchItem();
			// },

			fn_itemClick: function (itemId) {
				this.$router.push('/transactions/inventory/openingstock/items/'+itemId);
			},

			fn_edit: function (item) {
				this.$router.push({path:'/transactions/inventory/openingstock/items/'+item.transactionId+'/edit', query:{groupId:item.groupId}});
			},

			// fn_checkDrive: function(){
		 //        let self = this;
		 //        if(this.$root.CurrentBusiness.DataDrive){
		 //          this.fn_new();
		 //        }
		 //        else{
		 //          this.$root.fn_getTransactionCount(function(count){
		 //            if(count>=10){
		 //              self.$refs['ref_dialogDriveAlert'].dialog_setup_drive = true;
		 //            }
		 //            else{
		 //              self.fn_new();
		 //            }
		 //          })
		 //        }
		 //    },

			fn_new: function () {
				localStorage.setItem("SetDataDrive", 1);
				this.$router.push({path:'/transactions/inventory/openingstock/items/new', query:{tagId:this.guidWeb()}});
			},

			fn_comingSoon: function () {
				this.showToast("Coming Soon...");
			},

			fn_getBottomMenu: function (elementId, item, itemIndex) {

				if(item){
					this.selectedItem = item;
					this.itemIndex = itemIndex
				}

				let bottomMenu;

				// if(elementId == bottomSheetMenu.toolBar.Id){
				// 	bottomMenu = {"BottomMenu": [menuItem.help]};
				// }
				if(elementId == bottomSheetMenu.masterListItems.Id){
					bottomMenu = {"BottomMenu": [menuItem.edit]};
				}
				else if(elementId == bottomSheetMenu.moreFilters.Id){
					menuItem.filterCategory.selectedItem = this.selectionItems.categoryId ? this.selectionItems.categoryName : null;
					menuItem.filterBrand.selectedItem = this.selectionItems.brandId ? this.selectionItems.brandName : null;
					menuItem.filterCompany.selectedItem = this.selectionItems.companyId ? this.selectionItems.companyName : null;
					bottomMenu = {"BottomMenu": [menuItem.filterCategory, menuItem.filterBrand, menuItem.filterCompany]};
					if(this.selectionItems.categoryId || this.selectionItems.brandId || this.selectionItems.companyId){
						bottomMenu.BottomMenu.push(menuItem.clearAll);
					}
				}
				
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_openDialogAndroid: function (platform, name, ref, obj) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = obj.toolbarTitle;
				viewDialogObject.isBottomMenu = false;

				if(ref == 'ref_brand'){
					viewDialogObject.listId = listIdObject.brandListGUID;
				}
				else if(ref == 'ref_company'){
					viewDialogObject.listId = listIdObject.companyListGUID;
				}

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(obj.itemId && obj.itemName){
					paramObject.defaultValue = {"id":obj.itemId, "name":obj.itemName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, obj.functionName, tagId, paramObject, ref);
				
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function () {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				if(ref == 'ref_brand'){
					this.selectionItems.brandId = !isRemoved ? selectedValueId : null;
					this.selectionItems.brandName = !isRemoved ? selectedValueName : null;
				}
				else if(ref == 'ref_category'){
					this.selectionItems.categoryId = !isRemoved ? selectedValueId : null;
					this.selectionItems.categoryName = !isRemoved ? selectedValueName : null;
				}
				else if(ref == 'ref_company'){
					this.selectionItems.companyId = !isRemoved ? selectedValueId : null;
					this.selectionItems.companyName = !isRemoved ? selectedValueName : null;
				}

				localStorage.setItem('transaction_filter', JSON.stringify(this.selectionItems));

				isRemoved ? this.fn_closeDialog() : '';

				this.fn_searchItem();
			},

			// infiniteHandler($state) {
			// 	this.loading = true;
			// 	let filterObject = {}
			// 	filterObject.type = this.settings.transactionTypeId;
			// 	filterObject.limit = 10;
			// 	filterObject.startIndex = this.startIndex;
			// 	filterObject.search = this.searchValue.toLowerCase();

			// 	filterObject.itemFilter = {};
			// 	this.selectionItems.categoryId ? filterObject.itemFilter.categories = [this.selectionItems.categoryId] : '';
			// 	this.selectionItems.brandId ? filterObject.itemFilter.brands = [this.selectionItems.brandId] : '';
			// 	this.selectionItems.companyId ? filterObject.itemFilter.companies = [this.selectionItems.companyId] : '';

			// 	let self = this;
			// 	this.getItems("TransactionProductList", filterObject, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 				let responseJson = JSON.parse(response);
			// 				self.listItemObject.totalCount = responseJson.totalCount;

			// 				self.fn_getStockSummary(filterObject);

			// 				for(let i in responseJson.items){
			// 					self.listItemObject.items.push(responseJson.items[i]);	
			// 				}

			// 				self.startIndex = self.listItemObject.items.length;

			// 				if(self.listItemObject.items.length < self.listItemObject.totalCount){
			// 					$state.loaded();
			// 				}
			// 				else {
   //        						$state.complete(); 
   //      					}

   //      					self.loading = false;
   //      					self.searchItems = false;
			// 			},
			// 			onError: function (error) {
			// 				self.loading = false;
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
		 //    },

		 	fn_loadItems: function(search) {
				// this.loading = true;
				let filterObject = {}
				filterObject.type = this.settings.transactionTypeId;
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue ? this.searchValue.toLowerCase() : '';

				filterObject.itemFilter = {};
				this.selectionItems.categoryId ? filterObject.itemFilter.categories = [this.selectionItems.categoryId] : '';
				this.selectionItems.brandId ? filterObject.itemFilter.brands = [this.selectionItems.brandId] : '';
				this.selectionItems.companyId ? filterObject.itemFilter.companies = [this.selectionItems.companyId] : '';

				let self = this;
				this.getItems("TransactionProductList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
			              	let responseJson = JSON.parse(response);
			              	self.listItemObject.totalCount = responseJson.totalCount;
			              	self.fn_getStockSummary(filterObject);

			              	search ? self.listItemObject.items = [] : '';
			              	for(let i in responseJson.items){
			                	self.listItemObject.items.push(responseJson.items[i]);  
			              	}

			              	self.startIndex = self.listItemObject.items.length;
			              	self.loadMore = false;

			              	setTimeout(function(){
								self.showPlaceHolder = true;
							},300);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    },

		  	fn_searchItem: function () {
	        	this.startIndex = 0;
	        	this.listItemObject.items = [];
	        	this.fn_loadItems(true);
	      	},

	      	fn_debounceSearch: function(){
	             if (this.timeoutid != null){
	                clearTimeout(this.timeoutid);
	             }

	            this.timeoutid = setTimeout(() => { 
	                this.fn_searchItem();
	            },100);
	        },

		    fn_getStockSummary: function (filterObject) {
		    	var self = this;

				this.getItems('OpeningStockSummaryList', filterObject,
					{
						onSuccess: function(response){
							self.stockSummary = JSON.parse(response);
							self.stockSummary.totalAmount = self.roundUpto2Decimals(self.stockSummary.totalAmount);
							console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
		    },

			// fn_searchItem: function () {
			// 	this.searchItems = true;
			// 	this.startIndex = 0;
			// 	this.infiniteId += 1;
			// 	this.listItemObject.items = [];
			// },

			fn_showWebView: function () {
				let viewObject = {};
				let self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},
		},
		mounted: function(){
			tagId = this.$route.query.tagId;
			this.formId = this.$route.query.tagId;
			this.dialogStorageId = 'dialog_'+this.formId;

			this.fn_showWebView();
			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;

			let self = this;
			document.addEventListener('scroll', function () {
				self.scrollPositionTop = window.pageYOffset
			});

			if(localStorage.getItem('transaction_filter')){
				let data = JSON.parse(localStorage.getItem('transaction_filter'));
				this.selectionItems.brandId = data.brandId;
				this.selectionItems.brandName = data.brandName;
				this.selectionItems.categoryId = data.categoryId;
				this.selectionItems.categoryName = data.categoryName;
				this.selectionItems.companyId = data.companyId;
				this.selectionItems.companyName = data.companyName;
			}

			this.fn_loadItems();
		},
		beforeRouteLeave (to, from, next) {
		  	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				dialogjs.fn_checkAndCloseOpenDialogs(this);
				this.backButtonPress = false;
				next(false);
			}
			else if(this.qtySheet){
		  		this.qtySheet = false;
		  		this.backButtonPress = false;
		  		next(false);
		  	}
		  	else {
		  		this.backButtonPress ? localStorage.removeItem('transaction_filter') : '';
		  		next();
		  	}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/opening_stock/items.vue